import { render, staticRenderFns } from "./menuTabsdetalles.vue?vue&type=template&id=4ca82b70&scoped=true"
import script from "./menuTabsdetalles.vue?vue&type=script&lang=js"
export * from "./menuTabsdetalles.vue?vue&type=script&lang=js"
import style0 from "./menuTabsdetalles.vue?vue&type=style&index=0&id=4ca82b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca82b70",
  null
  
)

export default component.exports